export function Footer() {
  return (
    <footer>
      <div className="container py-6 flex justify-between items-center">
        <p className="text-sm text-muted-foreground">© 2024 TH. All rights reserved.</p>
      </div>
    </footer>
  );
}